export const state = {
  games: [],
};
